import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FilterIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 25)}
      {...svgProps}
      viewBox="0 0 572 571.3"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="60"
    >
      <path d="m539.8 44.2c-4.1-9.4-11.3-14.2-21.4-14.2h-464.8c-10.2 0-17.3 4.7-21.4 14.2-4.1 9.9-2.4 18.4 5.1 25.4l179 179v176.5c0 6.3 2.3 11.7 6.9 16.3l92.9 92.9c4.4 4.6 9.8 6.9 16.3 6.9 2.9 0 5.9-.6 9.1-1.8 9.4-4.1 14.2-11.3 14.2-21.4v-269.4l179-179c7.5-7 9.2-15.5 5.1-25.4z" />
    </SVG>
  );
};
